import { render } from "./SubmissionForm.vue?vue&type=template&id=331d89ac&scoped=true"
import script from "./SubmissionForm.vue?vue&type=script&lang=js"
export * from "./SubmissionForm.vue?vue&type=script&lang=js"

import "./SubmissionForm.vue?vue&type=style&index=0&id=331d89ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331d89ac"]])

export default __exports__